import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled from 'styled-components';
import { SdgRowProps } from '..';
import {
  SdgAlignmentsLayout,
  SdgAlignmentValence,
} from '../../../../../../../../../common/model/output/scores/sdg-alignment/types';
import { useSdgAlignmentsContext } from '../../context';
import { sdgAlignmentAreaWidth, getSdgRowHeight } from '../../shared';
import { SdgAlignmentBar } from './sdg-alignment-bar';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SdgAligmentBarProps extends SdgRowProps {}

export const SdgAlignmentBars = (props: SdgAligmentBarProps) => {
  const layout = useSdgAlignmentsContext().viewOptions.layout;

  return (
    <Root layout={layout}>
      <SdgAlignmentBar {...{ ...props, valence: SdgAlignmentValence.MISALIGNED }} />
      <Divider layout={layout} />
      <SdgAlignmentBar {...{ ...props, valence: SdgAlignmentValence.ALIGNED }} />
    </Root>
  );
};

const Root = styled.div<{ layout?: SdgAlignmentsLayout }>`
  ${sdgAlignmentAreaWidth}
  height: ${props => getSdgRowHeight(props.layout)};
  display: flex;
  align-items: center;
  > * {
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

const Divider = styled.div<{ layout?: SdgAlignmentsLayout }>`
  height: ${props => getSdgRowHeight(props.layout)};
  width: 1px;
  background-color: ${BouColor.TOOL_BORDER_DARK_GRAY};
`;
